import type {Expand} from '../types';

import {offerExpandCommon} from '../offer';
import {userExpandCommon} from '../user';
import {editionExpandCommon} from './edition';

export const programExpandCommon: Expand = {
  program: [
    'avatar_id',
    'background_id',
    [
      'coach_ids->expanded_coaches',
      {coach_title: 'Coach not found', name: 'Coach not found'},
      userExpandCommon,
    ],
    ['edition_ids', null, editionExpandCommon],
    ['user_id', null, userExpandCommon],
    ['employer_id', null, userExpandCommon],
    ['offer_id', null, offerExpandCommon],
  ],
};
